import React, { useReducer } from 'react';

export const FundRequestContext = React.createContext();

const initialStatus = {
    editMode: false,
    fundRequest: null,
    categories: [],
    selectedCategory: null,
    transactionsArray: null,
    uploadPath: null,
    formKey: null,
    expenseCategory: null,
    expenseIndex: null,
    expenseType: null,
    expenseItem: null,
    annualRates: null,
    vendors: null,
    selectedPayee: null,
};

const getTransactionKey = (category) => {
    switch (category) {
        case 'food_incidentals':
            return 'food';
        case 'travel_mileage':
            return 'travel';
        default:
            return category;
    }
};

const FundRequestReducer = (state, action) => {
    let transaction_key;

    switch (action.type) {
        case 'set_edit_mode':
            return {
                ...state,
                editMode: action.payload,
            };

        case 'set_annual_rates':
            return {
                ...state,
                annualRates: action.payload,
            };

        case 'set_vendors':
            return {
                ...state,
                vendors: action.payload,
            };

        case 'add_vendor':
            if (!state.vendors) {
                return {
                    ...state,
                    vendors: [action.payload],
                    selectedPayee: action.payload,
                };
            }
            return {
                ...state,
                vendors: [...state.vendors, action.payload],
                selectedPayee: action.payload,
            };

        case 'set_selected_payee':
            return {
                ...state,
                selectedPayee: action.payload,
            };

        case 'set_fund_request':
            console.log('setting fund_request', action.payload);
            return {
                ...state,
                fundRequest: action.payload,
            };

        case 'set_fund_request_with_expense_item':
            if (
                !action.fundRequest ||
                !action.fundRequest?.id ||
                !action.expenseItem
            )
                return state;
            const { expenseType } = state;
            const newUploadPath = `/v2/fundrequests/${action.fundRequest.id}/expenseitems/${expenseType}/${action.expenseItem.id}`;
            return {
                ...state,
                fundRequest: action.fundRequest,
                uploadPath: newUploadPath,
                expenseItem: action.expenseItem,
            };

        case 'set_categories':
            return {
                ...state,
                categories: action.payload,
            };

        case 'set_selected_category':
            console.log('setting selected category', action.payload);
            const newCategory = action.payload;
            transaction_key = getTransactionKey(newCategory.value);
            return {
                ...state,
                selectedCategory: newCategory,
                transactionsArray: `transactions_${transaction_key}`,
            };

        case 'set_upload_path':
            return {
                ...state,
                uploadPath: action.payload,
            };

        case 'set_expense_info':
            transaction_key = getTransactionKey(action.expenseCategory.value);
            const newFormKey = `transactions_${transaction_key}[${action.expenseIndex}]`;
            let uploadPath = null;
            if (
                state.fundRequest?.id &&
                typeof action.expenseItem?.id === 'number'
            ) {
                uploadPath = `/v2/fundrequests/${state.fundRequest.id}/expenseitems/${action.expenseType}/${action.expenseItem.id}`;
            }

            return {
                ...state,
                formKey: newFormKey,
                transactionsArray: `transactions_${transaction_key}`,
                uploadPath,
                expenseIndex: action.expenseIndex,
                expenseType: action.expenseType,
                expenseCategory: action.expenseCategory,
                selectedCategory: action.expenseCategory,
                expenseItem: action.expenseItem,
            };

        case 'set_expense_item': {
            if (
                typeof action.expenseItem?.id === 'number' &&
                state.fundRequest?.id
            ) {
                const newUploadPath = `/v2/fundrequests/${state.fundRequest.id}/expenseitems/${action.expenseType}/${action.expenseItem.id}`;
                return {
                    ...state,
                    uploadPath: newUploadPath,
                    expenseItem: action.expenseItem,
                };
            }
            return {
                ...state,
                expenseItem: action.expenseItem,
            };
        }

        case 'set_uploads': {
            const updatedExpenseItem = {
                ...state.expenseItem,
                uploads: action.payload,
            };
            let updatedFundRequest = Object.assign({}, state.fundRequest);
            updatedFundRequest[state.transactionsArray][state.expenseIndex][
                'uploads'
            ] = action.payload;

            return {
                ...state,
                fundRequest: updatedFundRequest,
                expenseItem: updatedExpenseItem,
            };
        }

        case 'reset_expense_item':
            return {
                ...state,
                editMode: false,
                formKey: null,
                transactionsArray: null,
                expenseIndex: null,
                expenseType: null,
                expenseCategory: null,
                expenseItem: null,
                uploadPath: null,
                selectedCategory: null,
            };

        case 'reset_fund_request':
            return {
                ...state,
                editMode: false,
                fundRequest: null,
                uploadPath: null,
                formKey: null,
                transactionsArray: null,
                expenseItem: null,
                expenseCategory: null,
                expenseType: null,
                expenseIndex: null,
                selectedCategory: null,
                vendors: null,
                selectedPayee: null,
            };

        default:
            return state;
    }
};

export const FundRequestContextProvider = (props) => {
    const [state, dispatch] = useReducer(FundRequestReducer, initialStatus);

    return (
        <FundRequestContext.Provider value={[state, dispatch]}>
            {props.children}
        </FundRequestContext.Provider>
    );
};
